// extracted by mini-css-extract-plugin
export var callCard = "_rs-0";
export var callMessageButton = "_rs-1";
export var helpIcon = "_rs-3";
export var helpIconContainer = "_rs-4";
export var verticalDivider = "_rs-2";